
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import KeyStatus from "@/components/keys/KeyStatus.vue";
import KeyTransit from "@/components/keys/actions/KeyTransit.vue";
import KeyRetrieve from "@/components/keys/actions/KeyRetrieve.vue";
import HandToHand from "@/components/keys/actions/HandToHand.vue";
import KeyWithdraw from "@/components/keys/actions/KeyWithdraw.vue";
import KeyWithdrawConnected from "@/components/keys/actions/KeyWithdrawConnected.vue";
import KeyDropAgency from "@/components/keys/actions/KeyDropAgency.vue";
import {Getter} from "vuex-class";
import KeyReturningDate from "@/components/keys/actions/KeyReturningDate.vue";
import moment from "moment";
import CustomChipLink from "@/components/CustomChipLink.vue";
import { mdiBell, mdiBellOffOutline } from "@mdi/js";

@Component({
    components: {
        KeyStatus,
        KeyTransit,
        KeyRetrieve,
        KeyDropAgency,
        KeyWithdraw,
        KeyWithdrawConnected,
        HandToHand,
        KeyReturningDate,
        CustomChipLink,
    },
})
export default class MobileListKeyItem extends Vue {

    get lang(): string {
        return this.$root.$i18n.locale;
    }

    get isCurrentUserHolder(): boolean {
        return this.item?.holder?.id === this.currentUser?.id;
    }

    get isKeyPage() {
        return !!this.$route?.params?.id;
    }

    get isKeyArchived() {
        return this.item?.archivedAt;
    }

    get isManager(): boolean {
      return !!this.item?.legitimateKeyAccess?.keyManagementId;
    }

    @Prop({default: {}})
    public item: any;

    @Prop({default: false})
    public description: boolean;

    @Prop({default: false})
    public location: boolean;

    @Prop({default: false})
    public fromRelaysPage: boolean;

    @Getter private currentUser: any;

    private displayChooseHour: boolean = false;
    private endCountdown: boolean = false;
    private showActions: boolean = false;

    private lateKey = (date) => moment(new Date(date), "YYYY-MM-DDTHH:mm:ss")
        .isBefore(moment().format("YYYY-MM-DDTHH:mm:ss"))

    private getTime = (date = null) => date
      ? moment(new Date(date), "YYYY-MM-DD HH:mm:ss").valueOf()
      : moment().valueOf()

    // whether or not show days in countdown
    private showDays = (date) => Math.abs(moment(new Date(date), "YYYY-MM-DD HH:mm:ss").valueOf() - moment().valueOf())
        > 24 * 60 * 60 * 1000

    private getDifference(date): string {
        date = new Date(date);
        const a = moment(date, "YYYY-MM-DD hh:mm");
        const b = moment();
        const diffDays = b.diff(a, "days");
        const diffHours = b.diff(a, "hours");
        const diffMinutes = b.diff(a, "minutes");
        if (diffMinutes < 60) {
            return diffMinutes % 60 + " " + String(this.$tc("countDown.minutes", diffMinutes % 60));
        } else if (diffHours < 24) {
            return diffHours % 24 + " " + String(this.$tc("countDown.hours", diffHours % 24)) + ", "
                + diffMinutes % 60 + " " + String(this.$tc("countDown.minutes", diffMinutes % 60));
        } else {
            return diffDays + " " + String(this.$tc("countDown.days", diffDays)) + ", "
                + diffHours % 24 + " " + String(this.$tc("countDown.hours", diffHours % 24)) + ", "
                + diffMinutes % 60 + " " + String(this.$tc("countDown.minutes", diffMinutes % 60));
        }
    }

    // extend holding key
    private validateTime(date) {
        this.displayChooseHour = false;
        this.$store.dispatch("keys/extendKeyHolding", {
            keyId: this.item?.id,
            newEstimatedEndDate: (new Date(date)).toISOString().substr(0, 19),
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n?.t("alerts.key.addTimeSuccess", {
                    key: this.item?.name,
                    time: moment(date).format("DD/MM/YYYY HH:mm"),
                }),
            });
            this.$emit("reset");
        });
    }
}
